import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPackAddToCart } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'outline';
  className?: string;
  href: string;
  /** Identifica desde qué sección se hizo clic (llega al Pixel de Meta). */
  source?: string;
  itemName?: string;
  value?: number;
};
export function CtaButton({
  children,
  size = 'lg',
  variant = 'primary',
  className = '',
  href,
  source = 'cta',
  itemName = 'Pack Pro-Series 30 piezas',
  value = 399
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-xl sm:text-2xl' : 'px-6 py-3.5 text-base sm:text-lg';
  const look = variant === 'primary' ? 'bg-chartreuse text-abyss hover:bg-[#d8ff3d] shadow-hard' : 'bg-transparent text-bone border-2 border-bone/40 hover:border-chartreuse hover:text-chartreuse';
  const isExternal = /^https?:\/\//.test(href);
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackPackAddToCart(source, itemName, value);
    if (!isExternal) return;

    // Fuerza la navegación al carrito incluso dentro de un iframe/preview.
    event.preventDefault();
    const opened = window.open(href, '_blank', 'noopener,noreferrer');
    if (!opened) {
      try {
        ;
        (window.top ?? window).location.href = href;
      } catch {
        window.location.href = href;
      }
    }
  };
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 font-display uppercase tracking-wide leading-none transition-all duration-200 active:translate-x-1 active:translate-y-1 active:shadow-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-chartreuse/50 ${sizing} ${look} ${className}`} data-id="element-24" data-mp="3otxnc9dis7gk">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-25" data-mp="ge42xjg2ibu8" />
    </a>;
}